import { render, staticRenderFns } from "./AliveCms.vue?vue&type=template&id=ceef227c&"
import script from "./AliveCms.vue?vue&type=script&lang=js&"
export * from "./AliveCms.vue?vue&type=script&lang=js&"
import style0 from "./AliveCms.vue?vue&type=style&index=0&id=ceef227c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports